/**
 * Contains the pre-defined widget groups in the order they're displayed in the Shell UI.
 */
import { SafeDictionary } from "@insite/client-framework/Common/Types";

const WidgetGroups = [
    "Testing",
    "Basic",
    "Common",
    "Contact Us",
    "Categories",
    "Category Details",
    "Header",
    "Catalog",
    "Products",
    "Product Details",
    "Order Approval List",
    "Order Approval Details",
    "Order History",
    "Order Details",
    "VMI Order History",
    "VMI Order Details",
    "Order Status",
    "Return Request (RMA)",
    "My Account",
    "Wish Lists",
    "RFQ Job Quotes",
    "RFQ Job Quote Details",
    "RFQ My Quotes",
    "RFQ Request Quote",
    "RFQ Quote Confirmation",
    "RFQ Quote Details",
    "Addresses",
    "Address Book Overlay",
    "My Lists",
    "Cart",
    "Cart Reminder Unsubscribe",
    "My Lists Details",
    "Account Settings",
    "Checkout - Shipping",
    "One Page Checkout",
    "One Page Checkout Confirmation",
    "Invoice History",
    "BudgetManagement",
    "Checkout - Review & Submit",
    "Sign In",
    "Product List",
    "Product Compare",
    "Order Confirmation",
    "Invoice Details",
    "Change Password",
    "Brands",
    "Brand Details",
    "Saved Payments",
    "Create Account",
    "Order Upload",
    "Quick Order",
    "Footer",
    "Reset Password",
    "Robots Txt",
    "Change Customer",
    "Location Finder",
    "Saved Order Details",
    "Saved Order List",
    "Store Pickup",
    "Mobile",
    "User List",
    "User Setup",
    "Static List",
    "Requisition Confirmation",
    "Requisitions",
    "Dealer Details",
    "News List",
    "News Page",
    "VMI Bins",
    "VMI Bin Details",
    "VMI Dashboard",
    "VMI Locations",
    "VMI Location Details",
    "VMI Reporting",
    "VMI Users",
    "Compact Header",
    "Manifest JSON",
    "Service Worker JS",
] as const;

export const WidgetGroupDisplayNames: SafeDictionary<string> = {
    BudgetManagement: "Budget Management",
    "Order Confirmation": "Checkout - Order Confirmation",
};

export default WidgetGroups;

/** Pre-defined widget groups for display in the Shell UI. */
export type WidgetGroup = (typeof WidgetGroups)[number];
